import { isStoredSessionStarted } from '@/lib/session'
import { check } from '@/api/auth'

/**
 * Verifica se pode entrar em rotas que
 * nao precisam de autenticacao. Ex: login.
 * @returns {Boolean}
 */
export function noAuthRoute () {
  return !isStoredSessionStarted()
}

/**
 * Verifica se pode entrar em rotas
 * que necessitam autenticacao.
 * @returns {Promise<Boolean>}
 */
export async function authRoute () {
  try {
    await check()
    return true
  } catch (e) {
    return false
  }
}
